import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewport } from "../../lib/animations";

// Scroll reveal wrapper. Renders a motion element that fades/slides up once
// it enters the viewport.
export function Reveal({ children, as = "div", variants = fadeUp, className = "", ...rest }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      variants={variants}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
